import React, { useEffect, useState } from 'react';
import './cabecalho.css';
import MarcaTexto from './MarcaTexto.svg';
import { Link } from 'react-router-dom';
import MenuNavegacao from '../../menuNavegacao/MenuNavegacao';
import { useAuth } from '../../../context/AuthContext';

const Cabecalho: React.FC = () => {
  const [larguraDaTela, setLarguraDaTela] = useState(window.innerWidth);
  const { user } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      setLarguraDaTela(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className='containerBk'>
      <nav className='containerCabecalho'>
        <div className='containerLogo'>
          <Link to={'/milshop'}>
            <img src={MarcaTexto} alt="logo da empresa - MilShop" />
          </Link>
        </div>
        <div className='containerEntrar'>
          <MenuNavegacao />
        </div>
      </nav>
    </header>
  );
};

export default Cabecalho;
